import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  email: "",
  roles: [],
  locationData: [],
  userData: {},
  selectedBottler: [],
  routes: [],
  activeDataElement: "Bottler Concentrate Forecast",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setRoles: (state, action) => {
      state.roles = action.payload;
    },
    setLocation: (state, action) => {
      state.locationData = action.payload;
    },
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    setSelectedBottler: (state, action) => {
      state.selectedBottler = action.payload;
    },
    setRoutes: (state, action) => {
      state.routes = action.payload;
    },
    setActiveDataElement: (state, action) => {
      state.activeDataElement = action.payload;
    },
  },
});

export const {
  setEmail,
  setRoles,
  setLocation,
  setUserData,
  setSelectedBottler,
  setRoutes,
  setActiveDataElement,
} = userSlice.actions;
export default userSlice.reducer;
